export const STYLES = {
  WRAPPER: 'w-[500px] flex flex-col overflow-auto pb-[50px] no-scrollbar no-scrollbar::-webkit-scrollbar',
  NAVIGATION_HEADER:
    'absolute top-0 left-0 right-0 flex items-center justify-between w-full bg-bw00 border-b-[1px] border-bw03 px-[34px] py-[17px]',
  MAIN_HEADING: 'font-metricR text-bw08 text-[28px] mt-[64px]',
  CHECKING_ACCOUNT: 'font-metricR text-bw07 text-[14px]',
  AVAILABLE_BALANCE: 'font-metricR text-bw07 text-[12px]',
  AVAILABLE_BALANCE_VALUE: 'font-metricR text-action03 text-[16px] text-right',
  FLEX_WRAPPER: 'flex items-center',
  DISCLAIMER: 'font-metricR text-bw06 text-[14px] text-left mt-[36px]',
  ACCOUNT_DETAILS: 'mt-[24px] mb-[24px] flex items-center justify-between',
  INPUT:
    ' border-b-[1.5px] border-action03 mt-[24px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none w-[120px] h-[40px] outline-none text-center font-metricR text-bw07 text-[31px]',
};

export const CHOOSE_METHOD_TYPES = {
  ACH: 'ACH',
  CHECK: 'CHECK',
  WIRE: 'WIRE',
  ASK_VENDOR: 'ASK_VENDOR',
  INTERNATIONAL_WIRE: 'INTERNATIONAL_WIRE',
};

export const PAYMENT_STATUS = {
  VALID: 'VALID',
};

export const TITLE_TYPE_MAP = {
  ACH: 'Bank Transfer (ACH)',
  CHECK: 'Mail a check',
  WIRE: 'Domestic Wire Transfer',
  INTERNATIONAL_WIRE: 'International Wire Transfer',
};
